export default __webpack_public_path__ + "static/media/search.045011aa.svg";